import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { lettingFeatureCommand } from '../../command/letting-feature-command';
import { LettingFeatureAdmin } from '../../model/letting-feature-admin';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { LettingFeatureAdminService } from '../data/letting-feature-admin.service';

@Injectable()
export class DeleteLettingFeaturesCommandHandler implements ICommandHandler {
  constructor(
    private readonly dataService: LettingFeatureAdminService,
    private readonly messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    return command instanceof MultiselectCommand && command.id === lettingFeatureCommand.deleteMany && command.items.length > 0;
  }

  execute(command: CommandBase): Observable<boolean> {
    const deleteCommand = command as MultiselectCommand<LettingFeatureAdmin>;
    return this.messageService.showDialog('LETTING_FEATURE.DELETE_SELECTED_CONFIRMATION', { value: deleteCommand.items.length }).pipe(
      switchMap(confirmed => {
        if (!confirmed) return of(false);

        return this.dataService.deleteMany(deleteCommand.items.map(item => item.id)).pipe(
          tap(() => {
            deleteCommand.items.forEach(item => {
              const index = deleteCommand.itemsSource.indexOf(item);
              if (index >= 0) deleteCommand.itemsSource.splice(index, 1);
            });
          }),
          map(() => true)
        );
      })
    );
  }
}
